import { api, download } from "./api";

export const getOrganization = () => api.get("/api/organization");
export const getScenarios = () => api.get("/api/scenarios");

export const getDataset = (unit) => api.get("/api/dataset", { params: { unit } });

/** Locally added order-book entries, beyond the dataset's own batches. */
export const getOrders = (unit) => api.get("/api/orders", { params: { unit } });
export const createOrder = (unit, payload) =>
  api.post("/api/orders", payload, { params: { unit } });
export const deleteOrder = (unit, id) =>
  api.del(`/api/orders/${encodeURIComponent(id)}`, { params: { unit } });
/** Patch-style edit of a batch (quantity, release/due, priority) — the
 * batch keeps its identity; the change applies at the NEXT re-plan. */
export const editOrder = (unit, id, payload) =>
  api.put(`/api/orders/${encodeURIComponent(id)}`, payload, { params: { unit } });

/** The code the next auto-numbered intake would take — a preview the
 *  form shows, not a number reserved for it. */
export const getNextOrderNumber = (unit, source, when) =>
  api.get("/api/orders/next-number", { params: { unit, source, when } });

/** The blank workbook a bulk intake is filled into. Served rather than
 *  described: a column list someone retypes into their own spreadsheet
 *  produces headers that are almost — but not quite — the ones the import
 *  matches on. */
export const downloadOrderImportTemplate = (unit) =>
  download("/api/orders/import-template", { unit });

/** What a filled-in workbook WOULD book, row by row, saving nothing. The
 *  dialog runs this first so the planner approves a list of orders rather
 *  than a filename. */
export const previewOrderImport = (unit, file) => {
  const form = new FormData();
  form.append("file", file);
  return api.post("/api/orders/import", form, { params: { unit, dry_run: 1 } });
};

/** Books every row of the workbook, or none of them. A file with any bad
 *  row is refused whole — a half-imported order book cannot be told apart
 *  from one the planner filled in incompletely. */
export const importOrders = (unit, file) => {
  const form = new FormData();
  form.append("file", file);
  return api.post("/api/orders/import", form, { params: { unit } });
};

/** Staged SAP process orders whose number a manual intake can take. */
export const getSapOrderNumbers = (unit) =>
  api.get("/api/orders/sap-numbers", { params: { unit } });

export const getCancelledOrders = (unit) =>
  api.get("/api/orders/cancelled", { params: { unit } });
export const cancelOrder = (unit, id) =>
  api.post(`/api/orders/${encodeURIComponent(id)}/cancel`, undefined, { params: { unit } });
export const restoreOrder = (unit, id) =>
  api.post(`/api/orders/${encodeURIComponent(id)}/restore`, undefined, { params: { unit } });

/** Administrator adds a plant under an existing site. */
export const createPlant = (payload) => api.post("/api/plants", payload);

/** Administrator adds a production unit under an existing plant. The unit
 * is born empty — the Unit Setup wizard commissions it. */
export const createUnit = (payload) => api.post("/api/units", payload);
/** Edit a unit's planning window (anchor, months ahead, history reach). */
export const updateUnit = (code, payload) =>
  api.put(`/api/units/${encodeURIComponent(code)}`, payload);
